export const searchDataSelector = ({ allData }) => allData;

// Granular selectors to avoid re-renders from unrelated state changes
export const selectedProfileSelector = (state) => searchDataSelector(state).allData.selectedProfile;
export const allStudentsSelector = (state) => searchDataSelector(state).allData.allStudents;
export const orgSearchSelector = (state) => searchDataSelector(state).allData.orgSearch;
export const studentLookupSelector = (state) => searchDataSelector(state).allData.studentLookup;
